
import { Vue, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import { BulkInventoryItemResource } from "@/models/api/barcodeSystem/inventory/bulkInventoryItems";
import { formatUoMQuantity } from "@/utils";
const inventoryModuleState = getModule(InventoryModule);

@Component({
  components: {
  }
})
export default class BulkInventoryItemHeader extends Vue {
  transLogsLoading: boolean = false;
  deleteLoading: boolean = false;

  get currentBulkInventoryItem(): BulkInventoryItemResource {
    return inventoryModuleState.currentBulkInventoryItem;
  }

  get companyId(): number {
    return inventoryModuleState.currentBulkInventoryItem
      ? inventoryModuleState.currentBulkInventoryItem.companyId
      : null; 
  }

  set companyId(val: number){
  }

  get companyName(): string {
    return inventoryModuleState.currentBulkInventoryItem && inventoryModuleState.currentBulkInventoryItem.company
      ? inventoryModuleState.currentBulkInventoryItem.company.companyName
      : null; 
  }

  set companyName(val: string){
  }


  get displayManufacturerCode(): string {
    return inventoryModuleState.currentBulkInventoryItem
      ? inventoryModuleState.currentBulkInventoryItem.displayManufacturerCode
      : null; 
  }

  set displayManufacturerCode(val: string){
  }

  get itemType(): string {
    return inventoryModuleState.currentBulkInventoryItem
      ? inventoryModuleState.currentBulkInventoryItem.itemType
      : null; 
  }

  set itemType(val: string){
  }

  get modelNumber(): string {
    return inventoryModuleState.currentBulkInventoryItem
      ? inventoryModuleState.currentBulkInventoryItem.modelNumber
      : null; 
  }

  set modelNumber(val: string){
  }

  get sku(): string {
    return inventoryModuleState.currentBulkInventoryItem
      ? inventoryModuleState.currentBulkInventoryItem.sku
      : null; 
  }

  set sku(val: string){
  }

  get itemDescription(): string {
    return inventoryModuleState.currentBulkInventoryItem
      ? inventoryModuleState.currentBulkInventoryItem.itemDescription
      : null; 
  }

  set itemDescription(val: string){
  }

  get quantity(): number {
    return inventoryModuleState.currentBulkInventoryItem
      ? inventoryModuleState.currentBulkInventoryItem.quantity
      : null; 
  }

  set quantity(val: number){
  }

  get uoMQuantity(): string {
    return inventoryModuleState.currentBulkInventoryItem
      ? formatUoMQuantity(inventoryModuleState.currentBulkInventoryItem.quantity, inventoryModuleState.currentBulkInventoryItem.stockSku)
      : null; 
  }

  set uoMQuantity(val: string){
  }


  get uoMs(): any[] {
    return inventoryModuleState.currentBulkInventoryItem && inventoryModuleState.currentBulkInventoryItem.stockSku && inventoryModuleState.currentBulkInventoryItem.stockSku.uoMs
      ? inventoryModuleState.currentBulkInventoryItem.stockSku.uoMs.map(v => ({
          label: `${v.name} (${v.abbreviation})`, 
          baseConversionFactor: v.baseConversionFactor, 
          isBase: inventoryModuleState.currentBulkInventoryItem.stockSku.baseUoM ? v.abbreviation == inventoryModuleState.currentBulkInventoryItem.stockSku.baseUoM.abbreviation : false,
          isDefault: inventoryModuleState.currentBulkInventoryItem.stockSku.defaultUoM ? v.abbreviation == inventoryModuleState.currentBulkInventoryItem.stockSku.defaultUoM.abbreviation : false,
          baseUoMAbbreviation: inventoryModuleState.currentBulkInventoryItem.stockSku.baseUoM ? inventoryModuleState.currentBulkInventoryItem.stockSku.baseUoM.abbreviation : ''})) 
      : null;
  }
 

  get warehouseLocationCode(): string {
    return inventoryModuleState.currentBulkInventoryItem
      ? inventoryModuleState.currentBulkInventoryItem.warehouseLocationCode
      : ""; 
  }

  set warehouseLocationCode(val: string){
  } 

  get facilityCode(): string {
    return inventoryModuleState.currentBulkInventoryItem
      ? inventoryModuleState.currentBulkInventoryItem.facilityCode
      : ""; 
  }

  set facilityCode(val: string){
  }

}
